<ng-container *ngIf="tabs$ | async as tabs">

  <ng-container *ngIf="tabs.length > 0">

    <app-radio-button-group *ngIf="tabs.length > 1" [selectedIndex]="getSelectedTabIndex(tabs)"
        size="small" class="inline" [ngClass]="{'disabled': disabled}">
      <ng-container *ngFor="let tab of tabs; let i = index">
        <app-radio-button-item (click)="selectedTab = tab.id" [selected]="selectedTab === tab.id">
          <app-radio-button-label [text]="tab.label | LANG"></app-radio-button-label>
        </app-radio-button-item>
      </ng-container>
    </app-radio-button-group>

    <app-grow-container [ngSwitch]="selectedTab" [trigger]="selectedTab">
      <app-control-page-footer-appliances *ngSwitchCase="'appliances'"></app-control-page-footer-appliances>
      <app-control-page-footer-powerlines *ngSwitchCase="'powerlines'"></app-control-page-footer-powerlines>
    </app-grow-container>

  </ng-container>

</ng-container>